import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		centeredCell: {
			display: "flex",
			width: "100%",
			alignItems: "center",
			justifyContent: "center",
		},
		reactTable: {
			"& .rt-tr-group .delete": {
				visibility: "hidden",
			},
			"& .rt-tr-group:hover .delete": {
				visibility: "visible",
			},
			"& .-pagination": {
				"& .-pageJump": {
					display: "none",
				},
				"& .-totalPages": {
					display: "none",
				}
			},
			
		},
		dialogText: {
			paddingTop: 5, 
			color: theme.palette.primary.main,
		},
		dialogContent: {
			[theme.breakpoints.down("xs")]: {
				display: "flex",
				alignItems: "flex-end",
				textAlign: "center",
			},
		},
		dialogActions: {
			[theme.breakpoints.down("xs")]: {
				height: "50%",
				justifyContent: "center",
				alignItems: "flex-start",
				paddingLeft: 30,
				paddingRight: 30,
				"& button": {
					flex: 1,
				},
			},
		},
		formControl: {
			minWidth: 200,

		},
		link: {
			"&:hover": {
				cursor: "pointer",
			}
		},
		tagChip: {
			margin: 2,
		},
		email: {
			color: theme.palette.custom.textPrimary
		},
		chip: {
			margin: 2
		},
		card: {
			padding: 24
		},
		roleChip: {
			margin: "2px 0",
		},
		routingChip: {
			margin: "2px 0",
		},
		tagStack: {
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-start",
			gap: 12,
		},
		billableCheck: {
			color: theme.palette.custom.primary, // brandOrange #E85F2A
		},
		bioLink: {
			display: "inline-flex",
			alignItems: "center",
			gap: 4,
			whiteSpace: "nowrap",
		},
		toolbar: {
			gap: theme.spacing(2),
		},
		// 16px between the table controls and the top of the table (MAX-4298).
		tableToolbar: {
			marginBottom: theme.spacing(2),
		},
		searchField: {
			minWidth: 280,
			[theme.breakpoints.down("xs")]: {
				minWidth: "100%",
			},
		},
		billableCount: {
			color: theme.palette.text.secondary,
		},
		memberCard: {
			padding: 16,
			marginBottom: 12,
			border: `1px solid ${theme.palette.divider}`,
		},
		memberCardRow: {
			display: "flex",
			justifyContent: "space-between",
			alignItems: "flex-start",
			padding: "4px 0",
			gap: 8,
		},
		memberCardLabel: {
			color: theme.palette.text.secondary,
			fontSize: 13,
			flexShrink: 0,
		},
		memberCardHeader: {
			marginBottom: 8,
		},
		memberCardBio: {
			paddingTop: 8,
		},
		emptyState: {
			padding: "48px 0",
		},
		pageDescription: {
			color: theme.palette.text.secondary,
		},
	} satisfies Record<string, CSSObject>);
};
